import React from 'react';
import { useTranslation } from 'react-i18next';

interface DiffPreviewProps {
    preview: string;
    onConfirm: () => void;
    onCancel: () => void;
    isConfirming: boolean;
}

const DiffPreview: React.FC<DiffPreviewProps> = ({ preview, onConfirm, onCancel, isConfirming }) => {
    const { t } = useTranslation(['conversationalEditor', 'common']);

    return (
        <div className="ce-diff-preview">
            <pre className="ce-diff-preview__content">{preview}</pre>
            <div className="ce-diff-preview__actions">
                <button
                    className="ce-diff-preview__btn ce-diff-preview__btn--confirm"
                    onClick={onConfirm}
                    disabled={isConfirming}
                >
                    {isConfirming ? t('common:submitting') : t('conversationalEditor:confirm')}
                </button>
                <button
                    className="ce-diff-preview__btn ce-diff-preview__btn--cancel"
                    onClick={onCancel}
                >
                    {t('common:cancel')}
                </button>
            </div>
        </div>
    );
};

export default DiffPreview;
